import ApiClient from '../../ApiClient';

class VoiceCredentialsAPI extends ApiClient {
  constructor() {
    super('voice/credentials', { accountScoped: true });
  }

  getCredentials() {
    return this.get();
  }
}

export default new VoiceCredentialsAPI();
